import axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export const GetDocumentTypesFilesService = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const documentTypeList = await axios.get(
        `${URL_AUTH}/api/general/v1/info/document-type/files`
      );
      resolve(documentTypeList.data.data);
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};
